export const WHATSAPP_URL = 'https://wa.me/447480205061';
export const track = (name, params = {}) => { if (window.gtag) window.gtag('event', name, params); };
